import { MessagePackager } from './message.packager';
import Emitter from 'tiny-emitter';
import * as EventType from '../eventBusType';
const messagePackager = new MessagePackager();
const EVENT_NAME = 'events';
/**
 * 消息收发器
 */
export class EventTranxceiver extends Emitter {
  constructor (socketClient, opts = { isSend: false, isReceive: false }) {
    super();
    this.socketClient = socketClient;
    this.opts = opts;
    this.listen();
  }
  /**
   * 监听消息
   */
  listen () {
    let self = this;
    if (this.socketClient) {
      this.socketClient.on(EVENT_NAME, function (buffer) {
        const msg = messagePackager.decodeEventMessage(buffer);
        let data = msg.data;
        self.emit(EventType.RECEIVED_MESSAGE, data);
      });
    }
  }
  /**
   * 发送消息
   * @param {*} instanceName 
   * @param {*} methodName 
   * @param {*} args 
   * @returns 
   */
  send (id, methodName, args) {
    if (!this.opts || !this.opts.isSend) {
      return;
    }
    if (this.socketClient) {
      const data = { id, methodName, args: args };
      let toUserId = this.socketClient.currentToUserId;
      const msg = messagePackager.encodeEventMessage(toUserId, data);
      this.socketClient.send(EVENT_NAME, msg);
    }
  }
  dispose () {
    this.socketClient = null;
  }
}